<template>
  <b-modal :id="modalId" title="Patient Activity Feed" size="xl" scrollable hide-footer body-class="pt-0">
    <PatientActivityFeed
      v-if="patientId"
      :patient-id="patientId"
      :compact="false"
      @open-medsync="$emit('open-medsync', $event)"
    />
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import PatientActivityFeed from '@/components/Patient/PatientActivityFeed.vue';

@Component({
  name: 'PatientActivityFeedModal',
  components: {
    PatientActivityFeed,
  },
})
export default class PatientActivityFeedModal extends Vue {
  @Prop({ default: 'activityFeedModal' }) modalId!: string;
  @Prop({ required: true }) patientId!: number;

}
</script>
